// import React from "react";
// import { useForm } from "react-hook-form";
// import { TextField, Button, CircularProgress, Container, Box, Typography, MenuItem } from "@mui/material";
// import { useUpdateUserMutation } from "../../../services/profileService";
// import { useSearchParams } from "react-router-dom";

// const UpdateUserDetails = () => {
// const [searchParams] = useSearchParams();
//   const token = searchParams.get("token");
//   const { register, handleSubmit, formState: { errors } } = useForm();
//   const [updateUser, { isLoading }] = useUpdateUserMutation();

//   const onSubmit = async (data) => {
//     try {
//       // Call the API with the form data and token
//       await updateUser({
//         token, // Include the token in the payload
//         job_title: data.job_title || null,
//         purpose: data.purpose || null,
//       }).unwrap();

//       alert("User details updated successfully!");
//     } catch (error) {
//       console.error("Error updating user details:", error);
//       alert("Failed to update user details.");
//     }
//   };

//   return (
//     <Container>
//       <Typography variant="h4" sx={{ mb: 4 }}>Update User Details</Typography>
//       <Box sx={{ mb: 4 }}>
//         <form onSubmit={handleSubmit(onSubmit)}>
//           {/* Job Title */}
//           <Box sx={{ mb: 3 }}>
//             <TextField
//               fullWidth
//               label="Job Title"
//               variant="outlined"
//               {...register("job_title")}
//               error={!!errors.job_title}
//               helperText={errors.job_title?.message}
//             />
//           </Box>

//           {/* Purpose */}
//           <Box sx={{ mb: 3 }}>
//             <TextField
//               select
//               fullWidth
//               label="Purpose"
//               {...register("purpose")}
//               error={!!errors.purpose}
//               helperText={errors.purpose?.message}
//             >
//               <MenuItem value="">Select Purpose</MenuItem>
//               <MenuItem value="New Role Design/Development">New Role Design/Development</MenuItem>
//               <MenuItem value="Onboarding">Onboarding</MenuItem>
//               <MenuItem value="Performance Management">Performance Management</MenuItem>
//               <MenuItem value="Succession Planning/Retirement">Succession Planning/Retirement</MenuItem>
//               <MenuItem value="Delegate & Elevate">Delegate & Elevate</MenuItem>
//             </TextField>
//           </Box>

//           {/* Submit Button */}
//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             disabled={isLoading}
//             sx={{ mb: 3 }}
//           >
//             {isLoading ? <CircularProgress size={24} /> : "Update Details"}
//           </Button>
//         </form>
//       </Box>
//     </Container>
//   );
// };

// export default UpdateUserDetails;


import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode"; // Import JWT decoder
import { useForm } from "react-hook-form";
import { TextField, Button, CircularProgress, Container, Box, Typography, MenuItem } from "@mui/material";
import { useUpdateUserMutation } from "../../../services/profileService";
import { useParams} from "react-router-dom";

const UpdateUserDetails = () => {
//   const [searchParams] = useSearchParams();
//   const token = searchParams.get("token");
  const { form_token } = useParams(); 
//   const token=useParams();
  const [userId, setUserId] = useState(null); // Extracted user ID from token
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [updateUser, { isLoading }] = useUpdateUserMutation();

  useEffect(() => {
    // Decode the token and extract user_id
    if (form_token) {
      try {
        const decoded = jwtDecode(form_token); // Decode the JWT
        setUserId(decoded?.user_id); 
        console.log(decoded?.user_id);
        // Extract and set the user_id
      } catch (error) {
        console.error("Invalid or expired token:", error);
        alert("Invalid or expired link. Please request a new one.");
        // Redirect to an error page if needed
      }
    } else {
      alert("No token found in the URL.");
      // Redirect if the token is missing
    }
  }, [form_token]);

  const onSubmit = async (data) => {
    try {
      // Call the API with the form data and userId
      await updateUser({
        user_id: userId, // Use decoded user_id
        job_title: data.job_title || null,
        purpose: data.purpose || null,
      }).unwrap();

      alert("User details updated successfully!");
    } catch (error) {
      console.error("Error updating user details:", error);
      alert("Failed to update user details.");
    }
  };

  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 4 }}>Update User Details</Typography>
      <Box sx={{ mb: 4 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Job Title */}
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Job Title"
              variant="outlined"
              {...register("job_title")}
              error={!!errors.job_title}
              helperText={errors.job_title?.message}
            />
          </Box>

          {/* Purpose */}
          <Box sx={{ mb: 3 }}>
            <TextField
              select
              fullWidth
              label="Purpose"
              {...register("purpose")}
              error={!!errors.purpose}
              helperText={errors.purpose?.message}
            >
              <MenuItem value="">Select Purpose</MenuItem>
              <MenuItem value="New Role Design/Development">New Role Design/Development</MenuItem>
              <MenuItem value="Onboarding">Onboarding</MenuItem>
              <MenuItem value="Performance Management">Performance Management</MenuItem>
              <MenuItem value="Succession Planning/Retirement">Succession Planning/Retirement</MenuItem>
              <MenuItem value="Delegate & Elevate">Delegate & Elevate</MenuItem>
            </TextField>
          </Box>

          {/* Submit Button */}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isLoading}
            sx={{ mb: 3 }}
          >
            {isLoading ? <CircularProgress size={24} /> : "Update Details"}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default UpdateUserDetails;
